import { render, staticRenderFns } from "./OnlineOff.vue?vue&type=template&id=2b89334c&scoped=true&"
import script from "./OnlineOff.vue?vue&type=script&lang=js&"
export * from "./OnlineOff.vue?vue&type=script&lang=js&"
import style0 from "./OnlineOff.vue?vue&type=style&index=0&id=2b89334c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b89334c",
  null
  
)

export default component.exports